module.exports = __webpack_public_path__ + "blackgrapes.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackgrapes.png
// module id = 855
// module chunks = 0